module.exports = __webpack_public_path__ + "img/clere-hub-pdf.aaf8ea6f.png";